const Cyklo = () => {
  return (
    <div>Cyklo</div>
  )
}

export default Cyklo